export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12132.116f9b2a.jpg";